import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { fmtDate, fullName } from "@/lib/format";
import { L } from "@/i18n";
import { Panel } from "./Panel";
import { StatusBadge } from "./StatusBadge";
import { PlanBadge } from "@/components/users/PlanBadge";

const TH = "px-4 py-3 text-left font-mono text-[10px] uppercase tracking-[0.15em] text-slate-500 font-medium";

export const RecentUsersTable = ({ users }) => (
  <Panel
    testId="recent-users-table"
    className="lg:col-span-8"
    title={L("Latest registrations", "Últimos registos")}
    subtitle={L("10 most recent users", "10 utilizadores mais recentes")}
    action={
      <Link to="/users" className="flex items-center gap-1 text-xs text-amber-400 hover:text-amber-300" data-testid="recent-users-view-all">
        {L("View all", "Ver todos")} <ArrowUpRight className="h-3.5 w-3.5" />
      </Link>
    }
  >
    <div className="-mx-5 sm:-mx-6 -mb-5 sm:-mb-6 overflow-x-auto">
      <table className="w-full min-w-[640px] text-sm">
        <thead className="border-y border-[#1e293b] bg-[#0f172a]/60">
          <tr>
            <th className={TH}>{L("Name", "Nome")}</th>
            <th className={TH}>{L("Username", "Utilizador")}</th>
            <th className={TH}>Email</th>
            <th className={TH}>{L("Plan", "Plano")}</th>
            <th className={TH}>{L("Status", "Estado")}</th>
            <th className={TH}>{L("Registered", "Registo")}</th>
          </tr>
        </thead>
        <tbody>
          {users.map((u) => (
            <tr key={u.id} className="border-b border-[#1e293b]/70 last:border-0 hover:bg-slate-800/30 transition-colors" data-testid={`recent-user-row-${u.id}`}>
              <td className="px-4 py-3 text-slate-200">
                {fullName(u)}
                {u.role === "admin" && <span className="ml-2 font-mono text-[10px] text-amber-500">ADMIN</span>}
              </td>
              <td className="px-4 py-3 font-mono text-xs text-slate-400">{u.username}</td>
              <td className="px-4 py-3 text-slate-400 truncate max-w-[220px]">{u.email}</td>
              <td className="px-4 py-3" data-testid={`recent-user-plan-${u.id}`}><PlanBadge user={u} /></td>
              <td className="px-4 py-3"><StatusBadge status={u.status} /></td>
              <td className="px-4 py-3 font-mono text-xs text-slate-400">{fmtDate(u.created_at)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </Panel>
);
